import resourcesServer from "@/services/config/resourcesServerConfigUnsecure";

export const login = (data) => {
  return resourcesServer.post("/user/login/", data);
};
